module.exports = require("@material-ui/core/TableBody");